export default __webpack_public_path__ + "static/media/information_detail_img.fc6d4ec8.png";